import axios from 'axios';

/** RFC 9457 / certificate API style bodies with `detail` or `title`. */
export function getMessageFromCertificateProblemDetailsBody(data: unknown): string | null {
  if (!data || typeof data !== 'object') {
    return null;
  }
  const record = data as Record<string, unknown>;
  const detail = typeof record.detail === 'string' ? record.detail.trim() : '';
  const title = typeof record.title === 'string' ? record.title.trim() : '';
  if (detail.length > 0) {
    return detail;
  }
  if (title.length > 0) {
    return title;
  }
  return null;
}

export function getCertificateProblemDetailsErrorMessage(err: unknown, fallback: string): string {
  if (axios.isAxiosError(err)) {
    const fromBody = getMessageFromCertificateProblemDetailsBody(err.response?.data);
    if (fromBody) {
      return fromBody;
    }
  }
  if (err instanceof Error && err.message.trim().length > 0) {
    return err.message;
  }
  return fallback;
}
